import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import Bookingintermediatrypage from "../components/common/PaymentSection/BookingIntermediatrypage";

const BookingConfirmationPage = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const selectedItem = location.state?.selectedItem;

  return (
    <div className="min-h-screen w-full bg-[#F8F9FA]">
      {/* Sticky header */}
      <div className="sticky top-0 z-10 flex items-center gap-3 px-6 py-4 bg-white border-b border-gray-200 shadow-sm">
        <button
          className="flex items-center justify-center w-8 h-8 rounded-full hover:bg-gray-100 transition-colors shrink-0"
          onClick={() => navigate(-1)}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="h-5 w-5 text-gray-600"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
          </svg>
        </button>
        <h1 className="text-lg font-bold text-gray-800">Booking Summary</h1>
      </div>

      {/* Full-width content */}
      <div className="w-full px-6 py-6">
        <Bookingintermediatrypage
          isOpen={true}
          pageMode={true}
          selectedItem={selectedItem}
          onClose={() => navigate(-1)}
          onConfirm={() => navigate("/booking-history")}
          redirectPath="/booking-history"
        />
      </div>
    </div>
  );
};

export default BookingConfirmationPage;
